const Filters = require('./Filters.js');
const generalEvents = require('../events/general-events');
const _ = require('lodash');

/**
 * Filtro para a tela de listagems de Faturas (Conciliações)
 * para os usuários padrões, ou seja aqueles que irão realizar
 * a conciliação de seus itens de fatura
 */
const ConciliacoesFilters = (function() {
  const container = $('#conciliacoes-list');
  const filtersContainer = $('#conciliacoes-filters');

  function ConciliacoesFilters() {
    const _this = this;
    const routeName = filtersContainer[0].dataset.route;
    const filters = new Filters(route(routeName), filtersContainer);

    nifty.body.overlay({fixed: true});

    filters.before = function() {
      nifty.body.overlay('show');
    };

    filters.after = function(html) {
      _this.resetDataView(html)
    };
  }

  /**
   * inicia os js utilizado na tabela
   */
  function init() {
    $('[data-toggle="tooltip"]').tooltip();
    generalEvents();
  }

  ConciliacoesFilters.prototype.resetDataView = function(html) {
    if (html) {
      container.html(html);
      init();
      nifty.body.overlay('hide');
      return;
    }

    nifty.body.overlay('hide');
  };

  return ConciliacoesFilters;
}());

module.exports = ConciliacoesFilters;
